<template>
    <div restartpage data-layout-type="regular" :data-layout-width="layout.LayoutWidth">
        <header :data-position="layout.HeaderAlignmentPublicName">
            <media
                v-if="layout.HeaderImagePath"
                data-logo
                :url="state.layout.HeaderImagePath"
                alt="Layout Logo"
                aria-hidden="true"
                type="Image"
            />
        </header>
        <languageswitcher v-if="state.languages !== undefined && state.languages.length > 1" />
        <main>
            <div data-main :data-text-position="layout.TextAlignmentPublicName">
                <h2 id="restart-survey-text">{{this.$store.getters.textResource(`rs_survey_changed_restart`)}}</h2>
                <button
                    type="button"
                    data-button
                    @click.prevent="userWantsToRestart"
                    href
                    autofocus
                    id="restart-survey-btn"
                    :value="this.$store.getters.textResource(`rs_restart_survey`)"
                    :disabled="state.global.showLoader"
                >{{this.$store.getters.textResource(`rs_restart_survey`)}}</button>
            </div>
        </main>
        <footer v-if="layout.RemovePoweredBy !== true" data-crowdtech-logo>
             <a :href="state.surveyInfo.culture === `nl-NL` ? `https://welcome.crowdtech.com/pdc` : `https://welcome.crowdtech.com/pbc`" target="_blank">
                <media
                    :url="`${state.settings.assetPath}powered-by-crowdtech-logo-${constrastCheck}.svg`"
                    alt="Crowdtech logo"
                    type="Image"
                />
            </a>
        </footer>
    </div>
</template>

<script>
import media from "@/components/Media.vue";
import Vue from "vue";
import store from "@/store/store";
import methods from "@/global/methods.js";
import languageswitcher from "@/components/LanguageSwitcher.vue";

Vue.use(store.state.global.allowedHtml);

export default {
    name: `restartpage-view`,
    components: {
        media,
        languageswitcher
    },
    computed: {
        state: function () {
            return this.$store.state;
        },
        layout: function () {
            return this.state.layout;
        },
        constrastCheck: function () {
            return methods.hexToRgb(this.layout.BackgroundColor);
        },
    },
    methods: {
        userWantsToRestart: function () {
            let data = {
                surveyId: this.state.surveyInfo.surveyId,
                respondentId: this.state.surveyInfo.respondentId,
                sessionId: this.state.surveyInfo.sessionId
            };

            // To prevent AJAX call spam
            document.activeElement.blur();
            
            methods.xhr({
                url: `/v1/Questionnaire/RestartRespondent`,
                setSurveyId: true,
                data: data,
                callback: (xhr) => {
                     let response = JSON.parse(xhr.responseText);
                     let actionObject = response.actionObject;
                     
                     if (response.action === `ShowSurveyPage`) {
                        this.$store.commit(`addLanguages`, response.languages);
                        this.$store.commit(`addPageData`, {
                            page: actionObject,
                        });
                        this.$router.replace(`Questionnaire`);
                    }
                    else if (response.action === `ShowDepublishPage`) {
                        this.$store.commit(`addSurveyInfo`, response);
                        this.$router.replace({
                            name: `DepublishPage`,
                            params: {
                                queueLink: actionObject.queueLink
                            },
                        });
                    }
                    else if (response.action === `ShowError`) {
                        this.validationMessage = response.message || actionObject.message;
                        this.$store.commit(`changeGlobal`, {
                            variableName: `showLoader`,
                            newValue: false,
                        });
                    }
                },
            });
        },
    },
    created() {
        this.$store.commit(`changeGlobal`, {
            variableName: `showLoader`,
            newValue: false,
        });
    },
};
</script>

<style scoped>
h2:empty {
    display: none;
}

[data-main] {
    button {
        background: var(--next-button-background-color);
        color: var(--next-button-font-color);
        border: 0;
        text-align: center;
        cursor: pointer;
    }

    &[data-text-position="Left"] {
        align-items: flex-start;
        text-align: left;
    }

    &[data-text-position="Right"] {
        align-items: flex-end;
        text-align: right;
    }

    &[data-text-position="Center"] {
        align-items: center;
        text-align: center;
    }
}

#restart-survey-text {
    width: 100%;
}
</style>